import React from "react";
import { func, string } from "prop-types";

import ErrorMessage from "../../../../shared/components/ErrorMessage";
import * as S from "./styled";

const HomeClaimErrorView = ({ className, handleClick }) => (
  <S.ErrorMessageContainer className={className}>
    <ErrorMessage />
    <S.CloseButton onClick={handleClick}>Close</S.CloseButton>
  </S.ErrorMessageContainer>
);

HomeClaimErrorView.propTypes = {
  handleClick: func.isRequired,
  className: string
};

HomeClaimErrorView.defaultProps = {
  className: ""
};

export default HomeClaimErrorView;
